/**
 * TicketChips — inline ticket badge(s) for an item row.
 * Shows up to 2 tickets inline; more = expandable count button.
 */
import React from 'react';
import { fmtTimeCst } from '../../../utils/cstUtils';
import { getTicketType, TICKET_TYPE_META } from '../squareDashboardUtils';

export default function TicketChips({ tickets, expanded, onExpand }) {
  if (!tickets || tickets.length === 0) return <span className="sq__muted">—</span>;

  if (tickets.length <= 2) {
    return (
      <div className="sq__itkt-chips">
        {tickets.map((t, i) => {
          const ttype = getTicketType(t);
          return (
            <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
              <span className={`sq__tkt-typebadge sq__tkt-typebadge--${ttype}`}>
                {TICKET_TYPE_META[ttype].label}
              </span>
              {t.ticketName && <span className="sq__itkt-chip">{t.ticketName}</span>}
              <span className="sq__itkt-poptime">{fmtTimeCst(t.time)}</span>
            </span>
          );
        })}
      </div>
    );
  }

  return (
    <button
      className={`sq__itkt-count${expanded ? ' active' : ''}`}
      onClick={e => { e.stopPropagation(); onExpand(); }}
      title="Click to see all tickets"
    >
      {tickets.length} tickets {expanded ? '▴' : '▾'}
    </button>
  );
}
